import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { FileImportExportService } from '../../service/file-import-export.service';
import { ImportAndExportDataFilter } from '../../model/importAndExportDataFilter';
import { SelectedVersion } from '../../model/SelectedVersionList';
import { environment } from '../../../../../environments/environment';

const apiServer = environment.apiServer;
const apiControl = '/InnDependency';

@Component({
  selector: 'app-inn-dependency',
  templateUrl: './inn-dependency.component.html',
  styleUrls: ['./inn-dependency.component.sass']
})
export class InnDependencyComponent implements OnInit {

  dataSetExportImportTable: any; 
  importAndExportDataFilter: ImportAndExportDataFilter = new ImportAndExportDataFilter();
  dtOptionsExportImportTable: DataTables.Settings = {};
  selectedValueList: Array<SelectedVersion> = [];
  selectedValue: SelectedVersion = new SelectedVersion();

  constructor(private http: HttpClient,private fileImportExportService: FileImportExportService, private spinner: NgxSpinnerService) {
    this.dataSetExportImportTable = [];

    fileImportExportService.http = http;
    fileImportExportService.spinner = spinner;
    fileImportExportService.apiControl = apiControl;
    fileImportExportService.downloadFileName = "INNDependency.xlsx";
   }

  ngOnInit() {

    //this.spinner.show();

    this.fileImportExportService.updateVisibilytyFieldFromeRole();

    this.dtOptionsExportImportTable = {
      pagingType: 'full_numbers',
      pageLength: 100,
      serverSide: true,
      processing: true,
      lengthChange: false,
      searching: false,
      autoWidth: true,
      paging: true,
      info: false,
      orderCellsTop: true,
      scrollY: 'calc(100vh - 215px)',

      language: {
        emptyTable: 'Нет данных',
        info: 'Отображено с _START_ по _END_ из _TOTAL_ записей',
        infoEmpty: 'Отображено с 0 по 0 из 0 записей',
        infoFiltered: '(отфильтровано из _MAX_ записей)',
        infoPostFix: '',
        thousands: ',',
        lengthMenu: 'Показывать по _MENU_ записей',
        loadingRecords: 'Загрузка ...',
        processing: 'Обработка ...',
        search: 'Поиск:',
        zeroRecords: '',
        paginate: {
          first: 'Первая',
          last: 'Последняя',
          next: 'След.',
          previous: 'Пред.'
        },
        aria: {
          sortAscending: ': activate to sort column ascending',
          sortDescending: ': activate to sort column descending'
        }
      },
      ajax: (dataTablesParameters: any, callback) => {

         dataTablesParameters.search = this.importAndExportDataFilter.search;
         if(this.selectedValue != undefined && this.selectedValue.version != "")
         dataTablesParameters.version = this.selectedValue.version;

        this.http.post<any>(apiServer + apiControl, dataTablesParameters, {})
          .subscribe(resp => {
            console.log(resp);
            callback({
              recordsTotal: resp.recordsTotal,
              recordsFiltered: resp.recordsFiltered,
              data:  resp.data
            });
            this.spinner.hide();
          });
        },
        columns: [
          { "data": "innPartner" },
          { "data": "namePartner" },
          { "data": "innHeadPartner" },
          { "data": "nameHeadPartner" }
      ]
      };
    this.http.get<Array<SelectedVersion>>(apiServer + "/versioninfo" + "/DistributorINNDependency")
    .subscribe(resp => {
      this.selectedValueList[0] = { author:"", version:"" }
      for (let index = 0; index < resp.length; index++) {
        this.selectedValueList[index + 1] = resp[index];
      }
    });

  }

  fileExport(event) {
    this.fileImportExportService.fileExport();
  }
 
 fileExportExample(event) {
   this.fileImportExportService.fileExportExample(event);
 }

 onImport(event) {
  this.fileImportExportService.onImport(event).then((data:any)=> {
    this.onFieldChange({ author:"", version:undefined });
  });
}

downLoadFile(data: any, type: string) {
  this.fileImportExportService.downLoadFile(data, type);
}

onFieldChange(event): void {
  this.selectedValue = event;
  var table = $('#exportImportTable').DataTable();
  table.draw();
}

}



// WEBPACK FOOTER //
// ./src/app/modules/user/components/inn-dependency/inn-dependency.component.ts